import { InjectionToken } from '@angular/core';

export interface AppInsightsConfig {
  instrumentationKey: string;
}

export interface AppConfig {
  apiBaseUrl: string;
}

export interface MsalConfig {
  clientId: string;
  authority: string;
  redirectUri: string;
  apiResourceUri: string;
  apiScope: string;
}

export interface EnvConfig {
  sessionTimeout: number;
  siteName: string;
  appConfig: AppConfig;
  appInsights: AppInsightsConfig;
  msalConfig: MsalConfig;
  production: boolean;
}

export const ENV_CONFIG = new InjectionToken<EnvConfig>('@@neediestcasesEnvironmentConfiguration');
